let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e3Fxr")).then(() => parcelRequire('cBA8g'));